const listItems = document.querySelectorAll('.box-buro__list');
const count = listItems.length;

function windowMedia(MediaQuery) {
  if (MediaQuery.matches) {
    for (let i = 0; i < count; i += 1) {
      const item = listItems[i].querySelectorAll('li').length;

      for (let j = 0; j < item; j += 1) {
        if (j > 1) {
          listItems[i].querySelectorAll('li')[j].style.display = 'none';
        }
      }

      if (item > 2) {
        const itemBtn = listItems[i].querySelectorAll('.box-buro__button');
        itemBtn[0].style.display = 'block';

        itemBtn[0].onclick = function moreList(e) {
          e.preventDefault();
          const list = this.parentElement.querySelectorAll('li');

          for (let k = 0; k < list.length; k += 1) {
            list[k].style.display = 'flex';
          }
          this.style.display = 'none';
        };
      }
    }
  } else {
    for (let i = 0; i < count; i += 1) {
      const item = listItems[i].querySelectorAll('li').length;

      for (let j = 0; j < item; j += 1) {
        listItems[i].querySelectorAll('li')[j].style.display = 'flex';
      }

      if (item > 2) {
        const itemBtn = listItems[i].querySelectorAll('.box-buro__button');
        itemBtn[0].style.display = 'none';
      }
    }
  }
}

const MediaQuery = window.matchMedia('(max-width: 768px)');
windowMedia(MediaQuery);
MediaQuery.addListener(windowMedia);
